import { type SvgProps, SvgWrapper } from '../utils';

export function FlickrIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M19.8571 2H4.14286C2.95982 2 2 2.95982 2 4.14286V19.8571C2 21.0402 2.95982 22 4.14286 22H19.8571C21.0402 22 22 21.0402 22 19.8571V4.14286C22 2.95982 21.0402 2 19.8571 2ZM8.45089 14.8125C6.88393 14.8125 5.61607 13.5446 5.61607 11.9777C5.61607 10.4107 6.88393 9.14286 8.45089 9.14286C10.0179 9.14286 11.2857 10.4107 11.2857 11.9777C11.2857 13.5446 10.0179 14.8125 8.45089 14.8125ZM15.5491 14.8125C13.9821 14.8125 12.7143 13.5446 12.7143 11.9777C12.7143 10.4107 13.9821 9.14286 15.5491 9.14286C17.1161 9.14286 18.3839 10.4107 18.3839 11.9777C18.3839 13.5446 17.1161 14.8125 15.5491 14.8125Z" />
    </SvgWrapper>
  );
}
